<div class="page page--landing-campaings">
  <div class="page__container">
    <h1 class="page__title  h2">{{ 'stats_pages_details_title' | translate }} {{ selectedPage?.description }}</h1>
    <div class="my-5">
      <div ngbDropdown class="d-flex flex-column dropdown_small_device custom">
        <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>
          stats_pages_details_resum_title
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
          <button ngbDropdownItem translate (click)="nav.select(1); dropdown.innerText = $event.target.innerText">
            stats_pages_details_resum_title
          </button>
          <button ngbDropdownItem translate (click)="nav.select(2); dropdown.innerText = $event.target.innerText">
            stats_pages_details_views_title
          </button>
          <button ngbDropdownItem translate (click)="nav.select(3); dropdown.innerText = $event.target.innerText">
            stats_pages_details_clic_title
          </button>
          <button ngbDropdownItem translate (click)="nav.select(4); dropdown.innerText = $event.target.innerText">
            stats_pages_details_devices_title
          </button>
        </div>
      </div>

      <ng-container>
        <div class="form-group row">
          <label class="col-sm-3" translate>send_sms_pages_modal_choose</label>
          <div class="col-sm-8">
            <ng-container>
              <ng-select
                #selectPage
                id="profile"
                bindValue="idPage"
                bindLabel="description"
                (search)="onSearch($event)"
                (change)="setSelectedPage($event)"
                [(ngModel)]="page"
                [items]="pages"
                [clearable]="false"
                class="form-control"
              >
                <ng-template ng-label-tmp let-item="item">
                  <span>{{ item.description + ' - ' + getUrl(item.idPage) }}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <span>{{ item.description + ' - ' + getUrl(item.idPage) }}</span>
                </ng-template>
              </ng-select>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device custom" [(activeId)]="activeId">
        <li [ngbNavItem]="1">
          <a ngbNavLink translate>stats_pages_details_resum_title</a>
          <ng-template ngbNavContent>
            <wsb-landing-info [page]="selectedPage" [url]="url"></wsb-landing-info>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink translate>stats_pages_details_views_title</a>
          <ng-template ngbNavContent>
            <wsb-landing-views [page]="selectedPage" [periods]="periods" [loadingPeriod]="loadingPeriod"></wsb-landing-views>
          </ng-template>
        </li>
        <li [ngbNavItem]="3">
          <a ngbNavLink translate>stats_pages_details_clic_title</a>
          <ng-template ngbNavContent>
            <wsb-landing-links [page]="selectedPage" [periods]="periods" [loadingPeriod]="loadingPeriod"></wsb-landing-links>
          </ng-template>
        </li>
        <li [ngbNavItem]="4">
          <a ngbNavLink translate>stats_pages_details_devices_title</a>
          <ng-template ngbNavContent>
            <wsb-landing-devices [page]="selectedPage" [periods]="periods" [loadingPeriod]="loadingPeriod"></wsb-landing-devices>
          </ng-template>
        </li>
      </ul>
    </div>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>
